<template>
  <v-card>
    <v-card-text>
      <form data-vv-scope="premDescForm">
        <v-container fluid grid-list-sm>
          <v-layout row wrap>
            <v-flex xs12 md4 lg4>
              <v-checkbox
                color="primary"
                :label="labels.onPrem"
                v-model="premDescForm.onPrem"
                :disabled="riskSurveyMode === 'Query' ? true : false"
              ></v-checkbox>
            </v-flex>
            <v-flex xs12 md4 lg4 v-if="riskSurveyMode === 'Query'">
              <v-subheader class="queryLabel">{{ labels.noOnPrem }}</v-subheader>
              <div class="queryValue">{{ premDescForm.noOnPrem }}</div>
            </v-flex>
            <v-flex xs12 md4 lg4 v-else>
              <v-text-field
                :label="labels.noOnPrem"
                v-model="premDescForm.noOnPrem"
                :error-messages="errors.collect('premDescForm.noOnPrem')"
                data-vv-name="premDescForm.noOnPrem"
                :data-vv-as="labels.noOnPrem"
                v-validate="'entry|numeric'"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md4 lg4 v-if="riskSurveyMode === 'Query'">
              <v-subheader class="queryLabel">{{ labels.hrsEmpty }}</v-subheader>
              <div class="queryValue">{{ premDescForm.hrsEmpty }}</div>
            </v-flex>
            <v-flex xs12 md4 lg4 v-else>
              <v-text-field
                :label="labels.hrsEmpty"
                v-model="premDescForm.hrsEmpty"
                :error-messages="errors.collect('premDescForm.hrsEmpty')"
                data-vv-name="premDescForm.hrsEmpty"
                :data-vv-as="labels.hrsEmpty"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md4 lg4 v-if="riskSurveyMode === 'Query'">
              <v-subheader class="queryLabel">{{ labels.alrmType }}</v-subheader>
              <div class="queryValue" v-for="item in filterAlrmTypeList" :key="item.label">{{ item.label }}</div>
            </v-flex>
            <v-flex xs12 md4 lg4 v-else>
              <v-autocomplete
                :items="alrmTypeList"
                v-model="premDescForm.alrmType"
                :label="labels.alrmType"
                item-text="label"
                item-value="value"
                data-vv-name="premDescForm.alrmType"
                :data-vv-as="labels.alrmType"
                :error-messages="errors.collect('premDescForm.alrmType')"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs12 md8 lg8 v-if="riskSurveyMode === 'Query'">
              <v-subheader class="queryLabel">{{ labels.alrmConn }}</v-subheader>
              <div class="queryValue">{{ premDescForm.alrmConn }}</div>
            </v-flex>
            <v-flex xs12 md8 lg8 v-else>
              <v-text-field
                :label="labels.alrmConn"
                v-model="premDescForm.alrmConn"
                :error-messages="errors.collect('premDescForm.alrmConn')"
                data-vv-name="premDescForm.alrmConn"
                :data-vv-as="labels.alrmConn"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md4 lg4>
              <v-checkbox
                color="primary"
                :label="labels.wtchmen"
                v-model="premDescForm.wtchmen"
                :disabled="riskSurveyMode === 'Query' ? true : false"
              ></v-checkbox>
            </v-flex>
            <v-flex xs12 md4 lg4>
              <v-checkbox
                color="primary"
                :label="labels.wtchmenArmd"
                v-model="premDescForm.wtchmenArmd"
                :disabled="riskSurveyMode === 'Query' ? true : false"
              ></v-checkbox>
            </v-flex>
            <v-flex xs12 md4 lg4 v-if="riskSurveyMode === 'Query'">
              <v-subheader class="queryLabel">{{ labels.wtchmenHrs }}</v-subheader>
              <div class="queryValue">{{ premDescForm.wtchmenHrs }}</div>
            </v-flex>
            <v-flex xs12 md4 lg4 v-else>
              <v-text-field
                :label="labels.wtchmenHrs"
                v-model="premDescForm.wtchmenHrs"
                :error-messages="errors.collect('premDescForm.wtchmenHrs')"
                data-vv-name="premDescForm.wtchmenHrs"
                :data-vv-as="labels.wtchmenHrs"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 v-if="riskSurveyMode === 'Query'">
              <v-subheader class="queryLabel">{{ labels.premRemarks }}</v-subheader>
              <div class="queryValue">{{ premDescForm.premRemarks }}</div>
            </v-flex>
            <v-flex xs12 v-else>
              <v-textarea
                v-model="premDescForm.premRemarks"
                :label="labels.premRemarks"
                :error-messages="errors.collect('premDescForm.premRemarks')"
                v-validate="'max:1000|entry'"
                data-vv-name="premDescForm.premRemarks"
                :data-vv-as="labels.premRemarks"
                :counter="1000"
                :rows="8"
              ></v-textarea>
            </v-flex>
          </v-layout>
        </v-container>
      </form>
    </v-card-text>
  </v-card>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { formatDisplayDate } from '@/utils/date'
import { alrmTypeList } from './index'

export default {
  data() {
    return {
      labels: {
        onPrem: 'Does insured and employee live on premise?',
        noOnPrem: 'How many?',
        hrsEmpty: 'Hours premise empty',
        alrmType: 'Type of Alarm',
        alrmConn: 'Alarm Connected To',
        wtchmen: 'Any watchmen employed?',
        wtchmenArmd: 'Are watchmen armed?',
        wtchmenHrs: 'Working hours',
        premRemarks: 'Premises Comments'
      },
      premDescForm: {
        survNo: undefined,
        verCnt: undefined,
        onPrem: false,
        noOnPrem: 0,
        hrsEmpty: undefined,
        alrmType: undefined,
        alrmConn: undefined,
        wtchmen: false,
        wtchmenArmd: false,
        wtchmenHrs: undefined,
        premRemarks: undefined,
        survDetType: 'premisesDescription'
      },
      actionLabel: {
        exit: 'Exit',
        save: 'Save',
        reset: 'Reset'
      },
      validStatus: {
        mandatory: true,
        optional: true
      },
      loading: false,
      loadingFlag: false,
      submitting: false,
      alrmTypeList: []
    }
  },
  watch: {
    displayErrorDialog: {
      handler: function (messages) {
        if (messages && messages.length > 0) {
          this.showErrorDialog = true
        }
      },
      deep: true
    }
  },
  computed: {
    displayErrorDialog() {
      return this.messages
    },
    riskSurveyMenu() {
      return this.$store.state.underwriting.specialFuncUWSettings.riskSurveySettings.menu
    },
    riskSurveyMaster() {
      return this.$store.state.underwriting.specialFuncUWSettings.riskSurveyMaster
    },
    riskSurveyDetails() {
      return this.$store.state.underwriting.specialFuncUWSettings.riskSurveyDetails
    },
    riskSurveyMode() {
      return this.$store.state.underwriting.specialFuncUWSettings.riskSurveyMode
    },
    filterAlrmTypeList() {
      return this.alrmTypeList.filter((list) => {
        return list.value === parseInt(this.premDescForm.alrmType)
      })
    }
  },
  methods: {
    async doInit() {
      this.premDescForm.survNo = this.riskSurveyMaster.survNo
      this.premDescForm.verCnt = this.riskSurveyMaster.verCnt
      this.loadInit()
    },
    loadInit() {
      this.premDescForm.onPrem = this.riskSurveyDetails.onPrem
      this.premDescForm.noOnPrem = this.riskSurveyDetails.noOnPrem
      this.premDescForm.hrsEmpty = this.riskSurveyDetails.hrsEmpty
      this.premDescForm.alrmType = parseInt(this.riskSurveyDetails.alrmType)
      this.premDescForm.alrmConn = this.riskSurveyDetails.alrmConn
      this.premDescForm.wtchmen = this.riskSurveyDetails.wtchmen
      this.premDescForm.wtchmenArmd = this.riskSurveyDetails.wtchmenArmd
      this.premDescForm.wtchmenHrs = this.riskSurveyDetails.wtchmenHrs
      this.premDescForm.premRemarks = this.riskSurveyDetails.premRemarks
    },
    formatDate(date) {
      return formatDisplayDate(date)
    },
    doReset() {
      this.premDescForm.onPrem = false
      this.premDescForm.noOnPrem = 0
      this.premDescForm.hrsEmpty = undefined
      this.premDescForm.alrmType = undefined
      this.premDescForm.alrmConn = undefined
      this.premDescForm.wtchmen = false
      this.premDescForm.wtchmenArmd = false
      this.premDescForm.wtchmenHrs = undefined
      this.premDescForm.premRemarks = undefined
    }
  },
  created() {
    this.alrmTypeList = alrmTypeList
  },
  mounted() {
    this.doInit()
  },
  beforeMount() {
    if (this.$store.state.underwriting.specialFuncUWSettings.init !== 1) {
      this.$store.dispatch('specialFuncUWInit').then(() => {
        this.$store.dispatch('riskSurveyInit').then(() => {
          this.doInit()
        })
      })
    } else {
      this.$store.dispatch('riskSurveyInit').then(() => {
        this.doInit()
      })
    }
  },
  mixins: [MessageMixin],
  components: {}
}
</script>
<style lang="scss">
@import '../../../../../assets/scss/accounting.scss';
</style>
